import qs from 'qs'
function getURLParams(props)
{
    return qs.parse((props).location.search, { ignoreQueryPrefix: true })
}

export default getURLParams
